import qAsk from "./qAsk";
const { publishReplay, refCount } = rxjs.operators;

const qAskReplay = (methodname, ...params) => handle$ =>
  handle$.pipe(
    qAsk(methodname, ...params),
    publishReplay(1),
    refCount()
  );

export default qAskReplay;
